import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export function useNotificationPermission() {
    const [permission, setPermission] = useState(
        typeof Notification !== 'undefined' ? Notification.permission : 'unsupported'
    );
    const { userData } = useSelector(state => state.user);

    useEffect(() => {
        if (!userData.userId || typeof Notification === 'undefined') return;

        const storedPermission = localStorage.getItem("notification-permission");

        if (Notification.permission !== "default") {
            localStorage.setItem("notification-permission", Notification.permission);
            setPermission(Notification.permission);
        } else if (!storedPermission) {
            Notification.requestPermission().then((newPermission) => {
                setPermission(newPermission);
                localStorage.setItem("notification-permission", newPermission);
            });
        } else {
            setPermission(storedPermission);
        }
    }, [userData.userId]);

    return permission;
}


export function requestNotificationPermission() {
    if (typeof Notification === 'undefined') {
        alert("This browser does not support notifications.");
        return;
    }

    if (Notification.permission === "denied") {
        alert("You have blocked notifications. Please enable them in browser settings.");
    } else {
        Notification.requestPermission().then((newPermission) => {
            localStorage.setItem("notification-permission", newPermission);
            window.location.reload();
        });
    }
}


export function sendNotification(title, body, image) {
    if (typeof Notification === 'undefined') {
        console.log("This browser does not support notifications.");
        return;
    }

    if (Notification.permission === "granted") {
        new Notification(title, { body, icon: image });
    }
}



export const NoficationToast = ({ image, username, message, onClick }) => {
    return (
        <div className="flex items-center gap-3 p-2" onClick={onClick}>
            <img src={image} alt="User Avatar" className="w-10 h-10 rounded-full" />
            <div className="text-sm">
                <p className="font-semibold">{username}</p>
                <p className="text-gray-600">{message}</p>
            </div>
        </div>
    );
};


export const showNotification = (image, username, message, onClick) => {
    toast.info(<NoficationToast onClick={onClick}  image={image} username={username} message={message} />, {
        icon: false,
        position: "top-left",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "bg-white shadow-lg rounded-lg border border-gray-200",
        bodyClassName: "p-3",
        progressClassName: "bg-blue-500",
    });
};